import { DateFilterTypeEnum } from "../enums/dateFilterType.enum";

export class FilterRequest {
  orgLevelId?: string;
  analyteId: string;
  startDate: number;
  endDate: number;
  dateFilterType: DateFilterTypeEnum;
}
